import React from 'react';
import DateBox from 'devextreme-react/date-box';
import { injectQuickDatePresets } from '../../utils/dateQuickPresets';

function QuickDateBase({
    value,
    onValueChanged,
    readOnly,
    type,
    displayFormat,
    showClearButton = true
}) {
    return (
        <DateBox
            value={value || null}
            type={type}
            displayFormat={displayFormat}
            showClearButton={showClearButton}
            readOnly={!!readOnly}
            useMaskBehavior={true}
            pickerType="calendar"
            onOpened={(e) => {
                injectQuickDatePresets(e?.component);
            }}
            onValueChanged={(e) => onValueChanged?.(e.value || null)}
            width="100%"
        />
    );
}

export function QuickDateTimeBox(props) {
    return <QuickDateBase {...props} type="datetime" displayFormat="dd-MM-yyyy HH:mm" />;
}

export function QuickDateOnlyBox(props) {
    return <QuickDateBase {...props} type="date" displayFormat="dd-MM-yyyy" />;
}

